import { bankServices } from "../../config/axios";
import {
    BANKNAMELIST_SUCCESS,
    BANKNAMELIST_FAILED,
    RESET_BANKNAMELIST,
    LOADING_BANKNAMELIST,
    BANKNAMELIST_NETWORKERROR,
} from '../types/index';

const resetbankNameList = () => {
    return { type: RESET_BANKNAMELIST };
};

const bankNameList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKNAMELIST });
    await bankServices
        .post("bankmasterbanknamelist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKNAMELIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKNAMELIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKNAMELIST_FAILED,
        payload: data
    };
}

export { resetbankNameList, bankNameList }